import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { UserAccount } from '@hdms/shared/page-frame/types';

@Component({
  selector: 'shrd-pf-ui-header-user-info-button',
  templateUrl: './header-user-info-button.component.html',
  styleUrls: ['./header-user-info-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserInfoButtonComponent {
  @Input() showUserName = true;
  @Input() userAccount: UserAccount;
  @Input() omitUserTitle = false;
  @Input() isSelected = false;
  @Input() accountIsSelectable = false;
  @Input() disabled = false;

  @Output() showAccountDetails = new EventEmitter<void>();
}
